module.exports = __webpack_public_path__ + "img/6.f319da3c.jpg";